module.exports = __webpack_public_path__ + "static/img/home_new7.e88e455c.jpg";